export const opMaintenanceMessage =
  'Der Online Plus Service von BEEM ist aufgrund von Wartungsarbeiten momentan nicht verfügbar. Wir erwarten, dass diese Arbeiten bis zum 4. November um 9 Uhr abgeschlossen sein werden. Vielen Dank für Ihr Verständnis.';
